import manager from "managers/app";
import { store } from "managers/state";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "views/app/App";

window.addEventListener("popstate", () => {
	manager.view.setViewFromUrl();
});

manager.view.setViewFromUrl(true);

ReactDOM.render(
	<React.StrictMode>
		<Provider store={store}>
			<App />
		</Provider>
	</React.StrictMode>,
	document.getElementById("root"),
);
